import { useAtom } from 'jotai'
import { userMeAtom } from '@/store/atoms/atom'

export const useAtomUserMe = () => {
  const [atomUserMe, setAtomUserMe] = useAtom(userMeAtom)

  return {
    atomUserMe,
    setAtomUserMe
  }
}
